import {
  takeLatest, select,
} from 'redux-saga/effects'
import request from '@/helpers/axios'
import downloadFileFromBlob from '@/helpers/downloadFileFromBlob'
import moment from 'moment'




import { GET_ACTION_LOG_FILE_URL } from '@/constants/apiRoutes'
import { GET_ACTION_LOG_FILE } from '@/store/actions/actionLog'
import { getSelectedElement, getTableParameters, getActivitiLogFilterValue, getDatesRange } from '@/store/selectors/actionLog'
import getTimeZoneOffset from '@/helpers/getTimeZoneOffset';



function* getActionLogFileSaga({payload}) {
  try {
    const {userId, tenantId, groupId} = yield select(getSelectedElement)
    const tableParameters = yield select(getTableParameters)
    const filterValue = yield select(getActivitiLogFilterValue)
    const { start, end } = yield select(getDatesRange)
    const response = yield request({
      url: GET_ACTION_LOG_FILE_URL({
        params: {
          userIds: filterValue['fullName'].length ? filterValue['fullName']?.map((item) => item.value) : [userId],
          actions: filterValue['action']?.map((item) => item.value),
          appNames: filterValue['appName']?.map((item) => item.value),
          objectTypes: filterValue['objectType']?.map((item) => item.value),
          tenantId,
          groupId,
          excludeColumns: payload.allColumns.filter(x => !tableParameters.activeFields.includes(x)),
          pageNumber: tableParameters.page - 1,
          pageSize: tableParameters.perPage,
          searchText: tableParameters.requestQuery || '',
          sort: [`${tableParameters.sort.field}: ${tableParameters.sort.direction}`],
          fromDate: start && moment(start).format('DD.MM.YYYY HH:mm'),
          toDate: end && moment(end).format('DD.MM.YYYY HH:mm'),
          timeZoneOffset: getTimeZoneOffset(),
        },
      }),
      method: 'get',
      options: {
        responseType: 'blob',
      },
    })  
    
    downloadFileFromBlob({
      blob: response.data,
      fileName: `Журнал действий пользователей на Платформе, ${moment(new Date()).format('DD.MM.YYYY')}.xlsx`,
    })

  } catch (error) {
    console.log(error)
  }

  return null
}

export default function* root() {
  yield takeLatest(GET_ACTION_LOG_FILE.REQUEST, getActionLogFileSaga)
}
